import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { DocumentationEvent } from './documentationContract';

/**
 * Events after which a documentation may show another current version: an edit or
 * a restore (`updatedEntity`), an upload, a removal, and a finished download.
 * Moves, failed uploads and the table state events leave the current version as it is.
 */
const VERSION_CHANGING_EVENT_TYPES: ReadonlySet<DocumentationEvent['type']> = new Set([
  DomainMessagesTypes.updatedEntity,
  DomainMessagesTypes.uploadedEntity,
  DomainMessagesTypes.documentationDeleted,
  DomainMessagesTypes.allDocumentations,
]);

/**
 * Whether the event may change which version a documentation shows (PT-7117); a failed
 * change does not. The payloads carry local ids or nothing, so the event cannot be
 * matched to one documentation.
 */
export function mayChangeShownVersion(event: DocumentationEvent): boolean {
  return !event.error && VERSION_CHANGING_EVENT_TYPES.has(event.type);
}
